
/**
 * 
 * @hidden
 */
export enum AggregateFunctions {

    /**
     * 
     */
    Average = 1,

    /**
     * 
     */
    Count = 2,

    /**
     * 
     */
    Max = 3,

    /**
     * 
     */
    Min = 4,

    /**
     * 
     */
    Sum = 5,
}
